<div class="boxWhite">

  <div class="headInfo" *ngIf="viajeSeleccionado">

    <div class="viaje">

      <div class="servicio">
        <span>SERVICIO</span>
        <h4>{{ viajeSeleccionado.servicio }}</h4>
      </div>
      <div class="item">
        <span>ID VIAJE</span>
        <p>{{ viajeSeleccionado.viajeCodigo }}</p>
      </div>
      <div class="item">
        <span>INICIO</span>
        <p>{{ viajeSeleccionado.fechahoraInicio | date:'HH:mm' }}</p>
      </div>
      <div class="item">
        <span>INICIO OR. PLAN.</span>
        <p>{{getInicioModif}}</p>
      </div>
      <div class="item">
        <span>ORIGEN</span>
        <p>{{ viajeSeleccionado.sucursalOrigen?.nombre || '--' }}</p>
      </div>
      <div class="item">
        <span>SENTIDO</span>
        <p>{{ viajeSeleccionado.sentido }}</p>
      </div>
      <div class="item">
        <span>DESTINO</span>
        <p>{{ viajeSeleccionado.sucursalDestino?.nombre || '--' }}</p>
      </div>
      <div class="item">
        <span>TIPO BUS R.</span>
        <p>{{ viajeSeleccionado.tipoMovilRequerido || '--' }}</p>
      </div>
      <div class="item">
        <span>ESTADO</span>
        <p><strong>{{ viajeSeleccionado.estado }}</strong></p>
      </div>
      <div class="item">
        <span>CONDUCTOR SUGERIDO</span>
        <p><strong>{{ getConductorSugerido() }}</strong></p>
      </div>
    </div>

    <div class="buttons">

      <ng-container *ngIf="viajeSeleccionado.confirmado">
        <button *ngIf="tienePermisoImprimirVoucherRuta()" class="btn btnBlack" (click)="getRutaViajePDF()" [disabled]="procesandoPdf">
          <img src="assets/img/icoPrint.svg" alt="">
        </button>
        <div class="font-weight-bold">CONFIRMADO</div>
      </ng-container>

      <!-- Contenedor para que ambos botones queden alineados -->
      <div *ngIf="!viajeSeleccionado.confirmado" style="display: flex; gap: 8px;">

        <!-- Confirmar & Imprimir & Iniciar -->
         <!--
        <button *ngIf="!puedeConfirmar()" [tooltip]="'Debes asignar bus y conductor al viaje'" class="btn btnGray me-2"
          style="cursor: not-allowed; pointer-events: auto;">
          Confirmar & Imprimir & Iniciar
        </button>

        <button *ngIf="puedeConfirmar()" (click)="confirmarEImprimirEIniciar()" class="btn btnOrange me-2">
          Confirmar & Imprimir & Iniciar
        </button>
        -->
        
        <!-- Confirmar & Imprimir -->
        <span *ngIf="mostrarBotonConfirmarImprimir && tienePermisoConfirmarViaje()" [tooltip]="getTooltipConfirmarImprimir()">
          <button
            class="btn me-2"
            [ngClass]="{'btnOrange': puedeConfirmar() && !edicionBloqueada(), 'btnGray': !puedeConfirmar() || edicionBloqueada()}"
            [style.cursor]="!puedeConfirmar() || edicionBloqueada() ? 'not-allowed' : null"
            [disabled]="!puedeConfirmar() || edicionBloqueada() || procesandoPdf"
            (click)="confirmarEImprimir()">
            Confirmar & Imprimir
          </button>
        </span>

        <!-- Confirmar -->
        <!--
        <button *ngIf="!puedeConfirmar()" class="btn btnGray" style="cursor: not-allowed; pointer-events: auto;"
          [tooltip]="'Debes asignar bus y conductor al viaje'">
          Confirmar
        </button>

        <button *ngIf="puedeConfirmar()" (click)="confirmar()" class="btn btnGreen">
          Confirmar
        </button>
        -->

      </div>

    </div>

  </div>

  <div class="scrollCont">
    <div class="boxCb" *ngIf="viajeSeleccionado">
      <div class="boxItems">

        <div class="row align-items-center" style="grid-column: 1 / -1;">
          <div class="col-9 d-flex justify-content-start">
            <span class="ms-2">MOVIL</span>
          </div>
          <div class="col-3 d-flex justify-content-center" *ngIf="viajeSeleccionado.estado !== 'EN_CURSO' && viajeSeleccionado.estado !== 'FINALIZADO'">

            <button *ngIf="hayMovilAsignado() && !edicionBloqueada() && tienePermisoQuitarMovil()" (click)="quitarMovil()" class="btn">
              <img src="assets/img/icoDeleteGray.svg">
            </button>

            <button *ngIf="!hayMovilAsignado() || edicionBloqueada()" class="btn" style="cursor: not-allowed; pointer-events: auto;"
              [tooltip]="edicionBloqueada() ? 'No se puede editar un viaje no iniciado' : 'No hay bus asignado'">
              <img src="assets/img/icoDeleteGray.svg">
            </button>

          </div>
        </div>

        <div class="row item" style="grid-column: 1 / -1;" *ngIf="viajeSeleccionado.estado !== 'EN_CURSO' && viajeSeleccionado.estado !== 'FINALIZADO'">
          <div class="col-12">
            <!--<div class="position-relative">
              <input type="text" class="form-control" [(ngModel)]="busSearchText"
                (ngModelChange)="onBusSearchChange($event)" placeholder="Buscar bus...">
              <div *ngIf="busLoading" class="position-absolute" style="right: 10px; top: 8px;">
                <small>Buscando...</small>
              </div>
              <div *ngIf="showBusResults && busSearchResults.length > 0"
                class="position-absolute w-100 bg-white border rounded shadow-sm"
                style="z-index: 1000; max-height: 500px; overflow-y: auto;">
                <div *ngFor="let bus of busSearchResults" class="p-2 border-bottom" style="cursor: pointer;"
                  (click)="selectBus(bus)">
                  <strong>{{ bus.numeroInterno }}</strong> - {{ bus.patente }} ({{ bus.tipoMovil?.codigo || 'N/A' }}) -
                  <span class="clBlue">{{ bus.estado }}</span>
                </div>
              </div>
            </div>-->
            <ng-select placeholder="BUSCAR BUS..." [multiple]="false" [items]="listaMoviles" bindLabel="numeroInterno"
              [(ngModel)]="movilSeleccionado" [searchFn]="buscarMovil" (change)="onMovilSelectionChange($event)"
              [readonly]="edicionBloqueada()">
              <ng-template ng-label-tmp let-item="item">
                <span>{{getInfoMovil(item)}}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                <span [class.option-disabled]="item.estado !== 'DISPONIBLE'"
                  [style.opacity]="item.estado !== 'DISPONIBLE' ? '0.5' : '1'"
                  [style.cursor]="item.estado !== 'DISPONIBLE' ? 'not-allowed' : 'pointer'"
                  [style.color]="item.estado !== 'DISPONIBLE' ? '#999' : 'inherit'">
                  {{getInfoMovil(item)}}
                </span>
              </ng-template>
            </ng-select>
          </div>

        </div>

        <div class="row" style="grid-column: 1 / -1;">

          <div class="item col-3 d-flex flex-column justify-content-center align-items-center">
            <span>ID</span>
            <p>{{ movilSeleccionado?.numeroInterno || viajeSeleccionado.movil?.numeroInterno || '--' }}</p>
          </div>

          <div class="item col-3 d-flex flex-column justify-content-center align-items-center">
            <span>PATENTE</span>
            <p>{{ movilSeleccionado?.patente || viajeSeleccionado.movil?.patente || '--' }}</p>
          </div>

          <div class="item col-3 d-flex flex-column justify-content-center align-items-center">
            <span>ESTADO</span>
            <p>{{ movilSeleccionado?.estado || viajeSeleccionado.movil?.estado || '--' }}</p>
          </div>

          <div class="item col-3 d-flex flex-column justify-content-center align-items-center">
            <span>T. BUS</span>
            <p>{{ movilSeleccionado?.tipoMovil?.codigo || viajeSeleccionado.movil?.tipoMovil?.codigo || '--' }}</p>
          </div>
        </div>

        <div class="row" style="grid-column: 1 / -1;">

          <div class="col-6 d-flex justify-content-center">

            <button *ngIf="puedeAsignarMovil() && viajeSeleccionado.estado !== 'EN_CURSO' && !asignandoMovil && !edicionBloqueada() && tienePermisoAsignarMovil()"
              class="btn btnOrange" (click)="asignarMovil()">ASIGNAR
            </button>

            <button *ngIf="puedeAsignarMovil() && viajeSeleccionado.estado !== 'EN_CURSO' && asignandoMovil && !edicionBloqueada() && tienePermisoAsignarMovil()"
              class="btn btnOrange">ASIGNANDO...
            </button>

            <button *ngIf="(!puedeAsignarMovil() || edicionBloqueada()) && viajeSeleccionado.estado !== 'EN_CURSO'" class="btn btnGray"
              style="cursor: not-allowed; pointer-events: auto;" [tooltip]="mensajeNoPuedeAsignarMovil">ASIGNAR
            </button>

          </div>

          <div class="col-6 d-flex justify-content-center">
            <button class="btn btnGray" (click)="verBuses()" *ngIf="viajeSeleccionado.estado !== 'EN_CURSO' && !edicionBloqueada()">
              VER MAS
            </button>
          </div>
        </div>

      </div>

      <div class="boxItems">

        <div class="row align-items-center" style="grid-column: 1 / -1;">
          <div class="col-9 d-flex justify-content-start">
            <span class="ms-2">CONDUCTOR</span>
          </div>
          <div class="col-3 d-flex justify-content-center" *ngIf="viajeSeleccionado.estado !== 'EN_CURSO' && viajeSeleccionado.estado !== 'FINALIZADO'">

            <button *ngIf="hayConductorAsignado() && !edicionBloqueada() && tienePermisoQuitarConductor()" (click)="quitarConductor()" class="btn">
              <img src="assets/img/icoDeleteGray.svg">
            </button>

            <button *ngIf="!hayConductorAsignado() || edicionBloqueada()" class="btn" style="cursor: not-allowed; pointer-events: auto;"
              [tooltip]="edicionBloqueada() ? 'No se puede editar un viaje no iniciado' : 'No hay conductor asignado'">
              <img src="assets/img/icoDeleteGray.svg">
            </button>
          </div>
        </div>

        <div class="row item" style="grid-column: 1 / -1;" *ngIf="viajeSeleccionado.estado !== 'EN_CURSO' && viajeSeleccionado.estado !== 'FINALIZADO'">
          <div class="col-12">
            <!--<div class="position-relative">
              <input type="text" class="form-control" [(ngModel)]="conductorSearchText"
                (ngModelChange)="onConductorSearchChange($event)" placeholder="Buscar conductor...">
              <div *ngIf="conductorLoading" class="position-absolute" style="right: 10px; top: 8px;">
                <small>Buscando...</small>
              </div>
              <div *ngIf="showConductorResults && conductorSearchResults.length > 0"
                class="position-absolute w-100 bg-white border rounded shadow-sm"
                style="z-index: 1000; max-height: 500px; overflow-y: auto;">
                <div *ngFor="let conductor of conductorSearchResults" class="p-2 border-bottom" style="cursor: pointer;"
                  (click)="selectConductor(conductor)">
                  <strong>{{ conductor.visibleId }}</strong> - {{ conductor.nombres }} {{ conductor.apellidoPaterno }}
                </div>
              </div>
            </div>-->
            <ng-select placeholder="BUSCAR CONDUCTOR..." [multiple]="false" [items]="listaConductores"
              bindLabel="visibleId" [(ngModel)]="conductorSeleccionado" [searchFn]="buscarConductor"
              (change)="onConductorSelectionChange($event)" [readonly]="edicionBloqueada()">
              <ng-template ng-label-tmp let-item="item">
                <span>{{ item.visibleId }}, {{item.nombres}} {{item.apellidoPaterno}}, {{item.estado}} </span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                <span [class.option-disabled]="item.estado !== 'DISPONIBLE'"
                  [style.opacity]="item.estado !== 'DISPONIBLE' ? '0.5' : '1'"
                  [style.cursor]="item.estado !== 'DISPONIBLE' ? 'not-allowed' : 'pointer'" [style.color]="
                      item.visibleId === getIdVisibleConductorSugerido() 
                        ? 'blue' 
                        : (item.estado !== 'DISPONIBLE' ? '#999' : 'inherit')
                      " [style.font-weight]="
                      item.visibleId === getIdVisibleConductorSugerido() ? 'bold' : 'normal'
                      ">
                  {{ item.visibleId }}, {{item.nombres}} {{item.apellidoPaterno}}, {{item.estado}}
                </span>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="row" style="grid-column: 1 / -1;">

          <div class="item col-3 d-flex flex-column justify-content-center align-items-center">
            <span>NOMBRE CB</span>
            <p>{{ conductorSeleccionado?.nombres || viajeSeleccionado.conductor?.nombres || '--' }}</p>
          </div>

          <div class="item col-3 d-flex flex-column justify-content-center align-items-center">
            <span>ID</span>
            <p>{{ conductorSeleccionado?.visibleId || viajeSeleccionado.conductor?.visibleId || '--' }}</p>
          </div>

          <div class="item col-3 d-flex flex-column justify-content-center align-items-center">
            <span>HRS DISP.</span>
            <p>{{ getHorasDisponibles(conductorSeleccionado || viajeSeleccionado?.conductor) }}</p>
          </div>

          <div class="item col-3 d-flex flex-column justify-content-center align-items-center">
            <span>TERM. CONT</span>
            <p>{{ conductorSeleccionado?.contratoSucursal?.nombre ||
              viajeSeleccionado.conductor?.contratoSucursal?.nombre ||
              '--'
              }}</p>
          </div>
        </div>

        <div class="row" style="grid-column: 1 / -1;">
          <div class="col-6 d-flex justify-content-center">

            <button *ngIf="puedeAsignarConductor() && viajeSeleccionado.estado !== 'EN_CURSO' && !asignandoConductor && !edicionBloqueada() && tienePermisoAsignarConductor()"
              class="btn btnOrange" (click)="asignarConductor()">ASIGNAR</button>

            <button *ngIf="puedeAsignarConductor() && viajeSeleccionado.estado !== 'EN_CURSO' && asignandoConductor && !edicionBloqueada() && tienePermisoAsignarConductor()"
              class="btn btnOrange">ASIGNANDO...
            </button>

            <button *ngIf="(!puedeAsignarConductor() || edicionBloqueada()) && viajeSeleccionado.estado !== 'EN_CURSO'" class="btn btnGray"
              style="cursor: not-allowed; pointer-events: auto;" [tooltip]="mensajeNoPuedeAsignarConductor">ASIGNAR
            </button>
          </div>

          <div class="col-6 d-flex justify-content-center">
            <button class="btn btnGray" (click)="verConductores()" *ngIf="!edicionBloqueada() && viajeSeleccionado.estado !== 'EN_CURSO'">VER MAS</button>
          </div>
        </div>

      </div>
    </div>

    <div class="paraderos">
      <!-- Loading indicator -->
      <div *ngIf="loading" class="text-center p-3">
        <p>Cargando paradas...</p>
      </div>

      <!-- No stops message -->
      <div *ngIf="!loading && paradas.length === 0" class="text-center p-3">
        <p>No hay paradas disponibles para este viaje.</p>
      </div>

      <!-- Stops list -->
      <ng-container *ngIf="!loading && paradas.length > 0">
















        <!-- First stop -->
        <div class="itemP inicio active" [ngClass]="{'noComercial': !paradas[0].comercial}">
          <div class="nombre">
            <p>{{ paradas[0].paradero.nombre }}</p>
            <span>(Inicio: {{ paradas[0].fechahoraPlanificada | date:'HH:mm' }})</span>
            <p class="servicio" *ngIf="paradas.length > 1 && paradas[0].codigoServicio == paradas[1].codigoServicio
              && paradas[0].comercial">{{paradas[0].codigoServicio}}</p>
            <p class="servicio" *ngIf="!paradas[0].comercial">VIAJE NO COMERCIAL</p>
          </div>
          <div class="date">
            <ng-container *ngIf="viajeSeleccionado.estado !== 'EN_CURSO'; else soloHora">
              <div class="change">
                <div class="grInput">
                  <button class="btn" (click)="restarCincoMinutos()" [disabled]="viajeIniciado() || guardandoHora || edicionBloqueada()" *ngIf="!viajeIniciado() && !edicionBloqueada() && tienePermisoEditarInicioViaje()">
                    <img src="assets/img/icoMenos.svg">
                  </button>
                  <input type="text" class="form-control" [(ngModel)]="fechaPrimeraParada" [readonly]="viajeIniciado() || edicionBloqueada() || !tienePermisoEditarInicioViaje()"
                    (input)="formatearTiempo($event)" (blur)="normalizarCampoHora()">
                  <button class="btn" (click)="sumarCincoMinutos()" [disabled]="viajeIniciado() || guardandoHora || edicionBloqueada()" *ngIf="!viajeIniciado() && !edicionBloqueada() && tienePermisoEditarInicioViaje()">
                    <img src="assets/img/icoMas.svg">
                  </button>
                </div>

                <button class="btn btnOrange" (click)="guardarHoraInicio()"
                  [disabled]="viajeIniciado() || guardandoHora || edicionBloqueada()" *ngIf="!viajeIniciado() && !edicionBloqueada() && tienePermisoEditarInicioViaje()">
                  {{ guardandoHora ? 'ACTUALIZANDO...' : 'GUARDAR H. INICIO' }}
                </button>
              </div>
            </ng-container>
            <ng-template #soloHora>
              <div class="hora">{{ paradas[0].fechahoraPlanificada | date:'HH:mm' }}</div>
            </ng-template>

            <div class="fecha">{{ paradas[0].fechahoraPlanificada | date:'dd MMM' }}</div>
          </div>
        </div>

        <!-- Middle stops -->
        <!--<ng-container *ngFor="let parada of paradas.slice(1, paradas.length - 1); let i = index">-->
        <ng-container *ngFor="let parada of paradas; let i = index">
          <ng-container *ngIf="i > 0 && i < paradas.length - 1">
            <div class="itemP"
              [ngClass]="{'noComercial': !parada.comercial, 'hidden': !parada.comercial && i != 0 && paradas[i - 1].seco == false}">
              <div class="nombre">
                <p>{{ parada.paradero.nombre }}</p>
                <p class="servicio" *ngIf="parada.codigoServicio == paradas[i + 1].codigoServicio && parada.comercial">
                  {{parada.codigoServicio}}</p>
                <p class="servicio" *ngIf="!parada.comercial">VIAJE NO COMERCIAL</p>
              </div>
              <div class="date">
                <div class="hora">{{ parada.fechahoraPlanificada | date:'HH:mm' }}
                  <ng-template #t [ngTemplateOutlet]="t" let-a
                    [ngTemplateOutletContext]="{ $implicit: muestraDiferenciaHorasMinutosParadero(parada.fechahoraPlanificada, parada.fechahoraReal) }">
                    <span *ngIf="a != ''">({{a}})</span>
                  </ng-template>
                </div>
                <div class="fecha">{{ parada.fechahoraPlanificada | date:'dd MMM' }}</div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Last stop -->
        <div *ngIf="paradas.length > 1" class="itemP final"
          [ngClass]="{'noComercial': !paradas[paradas.length - 1].comercial}">
          <div class="nombre">
            <p>{{ paradas[paradas.length - 1].paradero.nombre }}</p>
            <span *ngIf="paradas.length > 1">(Duración: {{ calculateDuration(paradas[0].fechahoraPlanificada,
              paradas[paradas.length - 1].fechahoraPlanificada) }})</span>
          </div>
          <div class="date">
            <div class="hora">{{ paradas[paradas.length - 1].fechahoraPlanificada | date:'HH:mm' }}
              <ng-template #t [ngTemplateOutlet]="t" let-a
                [ngTemplateOutletContext]="{ $implicit: muestraDiferenciaHorasMinutosParadero(paradas[paradas.length - 1].fechahoraPlanificada, paradas[paradas.length - 1].fechahoraReal) }">
                <span *ngIf="a != ''">({{a}})</span>
              </ng-template>
            </div>
            <div class="fecha">{{ paradas[paradas.length - 1].fechahoraPlanificada | date:'dd MMM' }}</div>
          </div>
        </div>
      </ng-container>

      <!--
      <button class="btn btnRed mx-auto d-block" *ngIf="tienePermisoCancelarViaje()" (click)="cancelar()">CANCELAR VIAJE</button>
      -->
    </div><!--paraderos-->
  </div>

</div>